var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolicia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.44 136.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.26,76.04h82.92c9.53,0,17.26,7.73,17.26,17.26v28.27H0v-28.27c0-9.53,7.73-17.26,17.26-17.26Z",
    style: {
      fill: "#166aa7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 121.57,
    width: 117.44,
    height: 14.58,
    style: {
      fill: "#e6b99d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.02,136.15H19.01v-59.74c0-1.79,1.45-3.24,3.24-3.24h10.06c1.78,0,3.23,1.43,3.24,3.21.02,2.42.04,4.85.07,7.27.04,4.48,1.84,8.76,5,11.92l16.39,16.39c0,8.06,0,16.12,0,24.19Z",
    style: {
      fill: "#393a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.82,136.15h38.01s0-59.74,0-59.74c0-1.79-1.45-3.24-3.24-3.24h-10.06c-1.78,0-3.23,1.43-3.24,3.21-.02,2.42-.04,4.85-.07,7.27-.04,4.48-1.84,8.76-5,11.92l-16.39,16.39c0,8.06,0,16.12,0,24.19Z",
    style: {
      fill: "#393a3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.37,79.57l-2.57-11.93h-24.78l-2.57,11.93s3.54,9.06,14.96,9.06,14.96-9.06,14.96-9.06Z",
    style: {
      fill: "#dda982"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.59,40.55c0,17.21-13.51,31.15-30.18,31.15s-30.18-13.95-30.18-31.15,13.51-31.15,30.18-31.15,30.18,13.95,30.18,31.15Z",
    style: {
      fill: "#e6b99d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.09,5.9c-3.81-3.88-16.33-5.9-25.68-5.9s-21.87,2.02-25.68,5.9c-2.9,2.94-3.68,8.39-4.39,29.77,0,0,15.83,1.74,30.07,1.74s30.07-1.74,30.07-1.74c-.71-21.38-1.5-26.82-4.39-29.77Z",
    style: {
      fill: "#166aa7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.07,38.9c-3.83,16.18,22.42,22.41,24.99,0h-24.99Z",
    style: {
      fill: "#10303e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.05,38.9c3.83,16.18-22.42,22.41-24.99,0h24.99Z",
    style: {
      fill: "#10303e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.41,32.73c-16.59,0-30.12,2.8-30.12,2.8,0,0,2.96,3.46,7.85,8.43,2.88,2.93,8.29-.8,22.27-.8v-.02.02c13.98,0,19.39,3.73,22.27.8,4.89-4.97,7.85-8.43,7.85-8.43,0,0-13.53-2.8-30.12-2.8Z",
    style: {
      fill: "#3279bc"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.48,22.35l1-.54c.18.39.39.65.63.77.24.12.52.11.85-.02.34-.14.57-.33.7-.58.13-.25.16-.49.09-.72-.04-.15-.11-.26-.21-.34s-.25-.12-.46-.12c-.14,0-.45.02-.92.07-.61.06-1.07,0-1.36-.15-.42-.22-.7-.58-.83-1.09-.09-.33-.1-.66-.02-1,.08-.34.23-.65.48-.91.24-.26.57-.48.97-.64.66-.27,1.2-.29,1.63-.08.43.22.73.61.91,1.19l-1.04.49c-.14-.31-.3-.51-.49-.59s-.43-.06-.73.06c-.31.12-.53.3-.66.52-.08.14-.1.3-.06.47.04.15.13.26.26.32.17.08.53.09,1.09.03.55-.06.98-.06,1.27,0s.54.19.75.41c.21.22.38.53.49.93.1.36.11.74.03,1.13-.08.39-.25.72-.51,1-.26.28-.62.51-1.07.69-.66.27-1.22.29-1.68.06-.46-.23-.82-.69-1.08-1.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.12,22.43l-1.28-6.53,3.98-1.15.22,1.1-2.9.84.28,1.45,2.69-.78.21,1.1-2.69.78.35,1.78,3-.87.21,1.1-4.08,1.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.29,18.15l-.13-1.12,2.38-.42.32,2.65c-.2.31-.51.61-.92.9-.41.28-.84.47-1.29.55-.57.1-1.09.04-1.55-.17-.46-.22-.83-.58-1.11-1.08-.28-.5-.46-1.07-.53-1.71-.08-.69-.04-1.33.14-1.91.17-.58.47-1.05.9-1.42.32-.28.74-.47,1.27-.56.68-.12,1.23-.04,1.65.24.42.28.72.71.9,1.3l-1.06.44c-.11-.31-.29-.55-.52-.7s-.51-.2-.83-.14c-.48.09-.84.34-1.08.76-.24.42-.32,1-.23,1.73.09.79.31,1.35.64,1.7.33.34.74.47,1.2.39.23-.04.46-.14.68-.29.22-.15.4-.32.55-.51l-.1-.84-1.26.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.55,13.37l1.11-.07.16,3.63c.03.58.06.95.09,1.12.06.27.18.49.37.64s.43.22.74.2c.32-.02.55-.11.7-.28.15-.17.24-.37.26-.6.02-.23.02-.61,0-1.14l-.16-3.71,1.11-.07.16,3.52c.04.8.03,1.38-.02,1.71-.05.34-.14.63-.3.86-.15.24-.36.44-.62.59-.27.15-.62.25-1.05.27-.53.03-.93-.01-1.21-.14-.28-.13-.5-.31-.67-.54-.17-.22-.28-.47-.34-.72-.09-.38-.15-.94-.18-1.7l-.16-3.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.35,19.78l.19-6.71,2.34.1c.59.02,1.02.1,1.28.23.26.13.47.36.62.67.15.32.22.67.21,1.07-.01.5-.15.92-.4,1.23-.25.32-.62.51-1.11.58.24.18.43.38.58.59.15.21.35.58.6,1.12l.64,1.34-1.33-.05-.76-1.49c-.27-.53-.46-.87-.56-1.01-.1-.14-.21-.24-.33-.29-.12-.05-.3-.09-.56-.1h-.23s-.08,2.79-.08,2.79l-1.11-.05Zm1.22-3.83l.82.03c.53.02.87,0,1-.04.13-.05.24-.14.32-.27.08-.13.12-.3.13-.5,0-.23-.04-.41-.13-.55-.1-.14-.23-.24-.41-.28-.09-.02-.36-.04-.81-.05l-.87-.04-.05,1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.76,20.1l.52-6.69,1.11.13-.52,6.69-1.11-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.72,13.68l2.01.38c.45.09.79.19,1.02.32.3.18.55.43.74.77.19.34.32.73.38,1.18s.06.98-.02,1.6c-.07.55-.19,1.01-.35,1.38-.2.46-.44.81-.73,1.06-.22.19-.5.32-.84.38-.25.05-.59.03-.99-.04l-2.07-.39.85-6.64Zm.96,1.33l-.56,4.4.82.16c.31.06.53.08.67.06.19-.02.35-.08.48-.19.14-.11.26-.3.37-.58.11-.28.2-.68.27-1.2.07-.51.08-.91.04-1.2-.04-.29-.12-.52-.23-.7-.11-.18-.27-.32-.47-.41-.15-.07-.45-.15-.9-.24l-.49-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.11,22.86l-1.18-.36-.17-1.62-2.14-.64-.74,1.35-1.15-.35,3.41-5.89,1.14.34.82,7.17Zm-1.47-3.18l-.25-2.64-1.21,2.2,1.46.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.32,16.69l1.93.8c.43.18.75.36.96.53.28.24.48.54.62.91s.21.78.21,1.24c0,.45-.08.98-.25,1.57-.15.52-.33.95-.54,1.29-.26.41-.55.71-.87.89-.24.14-.54.21-.88.2-.26,0-.58-.09-.97-.25l-1.98-.82,1.77-6.36Zm.76,1.51l-1.17,4.21.79.33c.3.12.51.19.65.2.19.02.35-.01.5-.09.15-.08.3-.24.45-.5.15-.26.3-.63.43-1.12.14-.49.21-.88.21-1.18s-.04-.54-.13-.74c-.09-.2-.22-.37-.4-.5-.14-.1-.42-.24-.85-.42l-.47-.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60.82,136.15h-3.8v-24.19c.19.16.86.67,1.86.68,1.05.01,1.76-.53,1.94-.68v24.19Z",
    style: {
      fill: "#2c4d67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 116.39,
    width: 21.84,
    height: 10.64,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#f5f0ee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 104.66,
    width: 24.75,
    height: 31.16,
    rx: 2.43,
    ry: 2.43,
    style: {
      fill: "#36607f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.96,
    y: 120.24,
    width: 11.49,
    height: 3.63,
    rx: 0.88,
    ry: 0.88,
    style: {
      fill: "#2c4d67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.96,
    y: 128.34,
    width: 11.49,
    height: 3.63,
    rx: 0.88,
    ry: 0.88,
    style: {
      fill: "#2c4d67"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.66,
    cy: 113.2,
    r: 2.41,
    style: {
      fill: "#94c998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.25,89.3h1.87c.48,0,.87.39.87.87v14.49h-3.62v-14.49c0-.48.39-.87.87-.87Z",
    style: {
      fill: "#36607f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicia);
export default __webpack_public_path__ + "static/media/policia.215e97e436b4435fdbe7951b6817a84d.svg";
export { ForwardRef as ReactComponent };